import { trpc } from '@/shared/api';

interface QuoteAssetDownloadParams {
  readonly quoteRequestId: string;
  readonly assetId: string;
}

interface QuoteAssetDownloadOptions {
  /** 다운로드 링크를 누를 때만 true — 열람 즉시 서명 URL 을 받지 않는다. */
  readonly enabled: boolean;
}

/**
 * 사용 이미지 원본의 서명 URL(quoteManagement.getAssetDownloadUrl, 견적 설계 §6-2).
 * 서명 URL 은 만료가 있으므로 캐시하지 않고 조회 때마다 새로 받는다.
 */
export const useQuoteAssetDownloadUrlQuery = (
  params: QuoteAssetDownloadParams,
  { enabled }: QuoteAssetDownloadOptions,
) =>
  trpc.quoteManagement.getAssetDownloadUrl.useQuery(params, {
    enabled,
    staleTime: 0,
    gcTime: 0,
    retry: false,
  });
